
import Vuex from 'vuex'

import actions from './actions'


export default new Vuex.Store({
  actions
})